import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonGroup } from 'core/elements';
import { ActionButtonType } from 'core/enums';
import { QuotesDashboardQuoteType, QuotesVsOrdersView } from 'reports/components/QuotesDashboard';
import { Color, Variant } from 'theme/enums';

interface IProps {
  onChange: (view: QuotesVsOrdersView) => void;
  type: QuotesDashboardQuoteType;
  value: QuotesVsOrdersView;
}

export const ViewToggle = ({ onChange, type, value }: IProps) => {
  const { t } = useTranslation();

  const getColor = useCallback(
    (viewType: QuotesVsOrdersView) => (value === viewType ? Color.PRIMARY : Color.NEUTRAL),
    [value]
  );

  const buttons = useMemo(() => {
    return [
      {
        color: getColor(QuotesVsOrdersView.QUANTITY),
        label: t('labelQuantity'),
        onClick: () => onChange(QuotesVsOrdersView.QUANTITY),
        type: ActionButtonType.BUTTON,
        variant: Variant.OUTLINED,
      },
      {
        color: getColor(QuotesVsOrdersView.COSTS),
        label: type === QuotesDashboardQuoteType.CUSTOMER ? t('labelPrice') : t('labelCost'),
        onClick: () => onChange(QuotesVsOrdersView.COSTS),
        type: ActionButtonType.BUTTON,
        variant: Variant.OUTLINED,
      },
    ];
  }, [getColor, onChange, t, type]);

  return <ButtonGroup buttons={buttons} />;
};
